import {
  getRestCnt,
  getHoliCnt,
  getHour,
  checkVacationDet,
  postVacationDet,
  getOtWorkSysInfo,
  getOtWorkStatus,
  getOtWorkHour,
  getOtDirectYn,
  postOtWorkDet,
  checkOtWorkDet,
  getScheduleStatus,
  getWorkOrgTimeList,
  checkScheduleDet,
  postScheduleDet,
  getRewardHoliCnt,
  getRewardList,
  checkRewardDet,
  postRewardDet,
  getAttendStatus,
  checkAttendDet,
  postAttendDet,
  checkCancelVacation,
  postCancelVacation,
  checkCancelReward,
  postCancelReward,
  getApprovalMgrApplFileEssYn,
  postCertiDet,
  checkHolCnt,
  getBizTripAppDet,
  postBizTripAppDet,
} from '@/api/application';
import { checkAnnualPlanDet } from '@/api/annualPlan';
import { getEmpCommonCode } from '@/api/code';

import applicationGetters from './applicationGetters';
import applicationMutations from './applicationMutations';

import routerNames from '@/const/routerConstants';
import applCode from '@/const/applCodeConstants';
import dayjs from 'dayjs';

/* 신청 */
const application = {
  state: {
    // ======================= COMMON =========================
    appMenu: {}, // 선택한 신청서 메뉴 정보
    reason: '',
    applYmd: '',
    reqSHm: '',
    reqEHm: '',
    requestHour: '',
    sYmd: '',
    eYmd: '',
    sYmdWeek: '',
    eYmdWeek: '',
    holDay: '', // 전체일수
    closeDay: '', // 적용일수
    workYmd: '',
    workWeek: '',

    // fileList: [],
    reasonFlag: '',
    // ======================= ATTEND =======================
    attendParam: {}, // 출퇴근신청 기본 파라미터
    bfShm: '',
    bfEhm: '',
    afShm: '',
    afEhm: '',
    // ======================= REWARD =======================
    rewardParam: {}, // 보상휴가 기본 파라미터
    rewardList: [],
    useRewardList: [], // 사용한 보상휴가 목록
    reqTime: 0,
    // ======================= SCHEDULE =======================
    scheduleParam: {}, // 근무스케줄 기본 파라미터
    searchWorkTypeCd: '',
    workOrgCd: '', // 근무유형 코드
    intervalCd: '', // 근무주기
    stdYmd: '',
    dayGubunCd: '',
    scheduleTimeCd: '', // 변경한 근무시간코드

    workOrgNm: '',
    workOrgTimeList: [],
    scheduleTimeNm: '',
    // ======================= OTWORK =========================
    otworkParam: {}, // 연장근무 기본 파라미터
    reqTimeCd: '', // 휴일근무 보상구분 (A:수당, B:대체휴가, C:보상시간)
    restHour: '',
    inoutYn: 'Y',
    alterYmd: '',
    alterWeek: '',
    alterGntCd: '',
    holOtHour: '',
    hour: '',
    altvacApplStatus: 'N', // 대체휴가 자동신청 여부 및 신청상태 (N / 11~99)
    alterGntNm: '',
    holYn: 'N', // 휴일여부
    applGubun: '', // A: 사후, B: 사전
    inOut: '|',
    // ======================= VACATION =======================
    vacationParam: {}, // 근태 기본 파라미터
    alterVacation: {}, // 선택한 휴일 근무일 정보
    gntCd: {}, // 근태명
    gntGubunCd: '',
    orgLvl: '',
    halfYn: 'N', // 반차 여부
    restCnt: '', // 잔여일수
    applYmdWeek: '',
    holWorkYmd: '', // 대체휴일
    holWorkYmdCombo: '',
    gntFileEssYn: '', //2025.03.19 근태별 첨부파일 필수여부

    // ======================= BIZTRIP =======================
    bizTripGntNm: '', // 출장신청 근태명
    bizTripCols: [], // 출장신청 입력항목 (**동적컬럼)
    bizTripTitle: {}, // 출장신청 제목 (**고정컬럼 | bizTripCols에서 추출한 값)
    bizTripSabunNote: null, // 출장신청동행인 추가항목 (**예외컬럼 | bizTripCols에서 추출한 값, userNote 기안자의 메모내용도 저장)
    bizTripDynamicCols: [], // 출장신청 동적컬럼 (** bizTripCols에서 추출한 값)
    bizTripData: {}, // 출장신청 입력내용 (기본표기내용이 있을 수 있음!)
    bizTripJoiner: [], // 출장신청 동행인 목록

    // ======================= CERTI =======================
    certiParam: {}, // 제증명신청 기본 파라미터
    purpose: '',
    submitOffice: '',
    address: '',
    addrYn: 1,
    resNoYn: 1,
    gempYn: 1,
    noteYn: 1,
    periodYyCnt: 0,
    periodMmCnt: 0,
    purposeCdList: [],

    // ======================= CANCEL =======================
    searchBfApplSeq: '', // 기존 신청서 seq
    // ======================= PLAN =======================
    planParam: {}, // 연차계획 파라미터
    // ============ 2025.03.12 연장근무시간 직접입력 추가 ========================
    otInfoDirectYn: '', // 연장근무정보 직접입력가능여부
    directRequestHour: '', // 직접입력 신청시간
    directRestHour: '', // 직접입력 휴게시간
  },
  getters: applicationGetters,
  mutations: applicationMutations,
  actions: {
    // ======================= MENU =======================
    /* 메뉴 선택시 기본 데이터 셋팅 및 다음페이지 리턴 */
    async FETCH_MENU_ACTION({ rootState, dispatch, commit }, params) {
      // 0. 초기화
      commit('RESET_ELA_STATE');
      commit('RESET_APPLICATION_STATE');

      try {
        const applCd = params.applCd;
        const gntGubunCd = params.gntGubunCd;
        const todayYMD = dayjs().format('YYYYMMDD');
        const ssnSabun = rootState.userData.ssnSabun;

        await dispatch('FETCH_ELA_APPL_INFO', {
          searchApplCd: applCd,
          adminYn: 'N',
          authPg: 'A',
          searchApplSeq: null,
          searchApplSabun: ssnSabun,
          searchApplInSabun: ssnSabun,
          searchApplStatusCd: '21', // 신청
          searchApplYmd: todayYMD,
        });

        commit('SET_APP_MENU', params);
        commit('SET_APPL_ORG_LVL', params.applOrgLvl || '');

        let routerName = routerNames.StartDate;
        if (applCd === applCode.Vacation) {
          // 근태
          commit('SET_GNT_GUBUN_CD', gntGubunCd);
          routerName =
            gntGubunCd === null || gntGubunCd === '11' // 근태신청 or 대체휴가
              ? routerNames.GntGubunMenu // 근태종류 선택 메뉴
              : routerNames.GntTypeMenu; // 근태명 선택 메뉴
        } else if (applCd === applCode.BizTrip) {
          // 출장신청
          commit('SET_GNT_GUBUN_CD', gntGubunCd);
          routerName = routerNames.BizTripTypeMenu; // 출장구분 선택 메뉴
        } else if (applCd === applCode.OtWork) {
          commit('SPINNER/ON_APP_SPINNER', {}, { root: true }); // 상위나 형제 actions 접근시
          // 연장근무
          // 휴일근무 보상기준 조회
          const reqTimeCd = await dispatch('FETCH_OT_WORK_SYS_INFO');

          // 대체휴가 코드 조회
          if (reqTimeCd === 'B') {
            await dispatch(
              'CODE/FETCH_GNT_CD',
              {
                cmd: 'alterGntCdApp',
              },
              { root: true }, // 상위나 형제 actions 접근시
            );
          }
        } else if (applCd === applCode.Schedule) {
          // 근무스케쥴
        } else if (applCd === applCode.Reward) {
          // 보상휴가
          commit('SET_GNT_GUBUN_CD', '10'); // 임시
          commit('SET_S_YMD', todayYMD);
          commit('SET_E_YMD', todayYMD);

          routerName = routerNames.GntTypeMenu;
        } else if (applCd === applCode.Attend) {
          // 출퇴근변경신청
          // pass
        } else if (
          applCd === applCode.CancelVacation ||
          applCd === applCode.CancelReward
        ) {
          // 근태취소, 보상휴가취소
          routerName = routerNames.CancelMenu;
        } else {
          alert('준비중입니다.');
          return false;
        }
        commit('SPINNER/OFF_APP_SPINNER', {}, { root: true }); // 상위나 형제 actions 접근시
        return routerName;
      } catch (error) {
        console.log(error);
      }
    },

    /* 제증명신청서 종류 선택시 기본 데이터 셋팅 및 다음페이지 리턴 */
    async FETCH_CERTI_MENU_ACTION({ rootState, dispatch, commit }, params) {
      // 0. 초기화
      commit('RESET_ELA_STATE');
      commit('RESET_APPLICATION_STATE');

      try {
        const applCd = params.applCd;
        const todayYMD = dayjs().format('YYYYMMDD');
        const ssnSabun = rootState.userData.ssnSabun;

        await dispatch('FETCH_ELA_APPL_INFO', {
          searchApplCd: applCd,
          adminYn: 'N',
          authPg: 'A',
          searchApplSeq: null,
          searchApplSabun: ssnSabun,
          searchApplInSabun: ssnSabun,
          searchApplStatusCd: '21', // 신청
          searchApplYmd: todayYMD,
        });

        commit('SET_APP_MENU', params);
        commit('SET_APPL_ORG_LVL', params.applOrgLvl || '');
        commit('SET_APPL_YMD', todayYMD); // 신청일 파라미터 셋팅 (날짜선택이 없기 때문에)

        await dispatch('FETCH_PURPOSE_CD_LIST'); // 용도 코드목록조회

        let routerName = routerNames.SelectCertiOptions;
        commit('SPINNER/OFF_APP_SPINNER', {}, { root: true }); // 상위나 형제 actions 접근시
        return routerName;
      } catch (error) {
        console.log(error);
      }
    },

    // ======================= PLAN =======================

    // 연차계획작성 - 확인
    async VALIDATE_PLAN_DET({ getters, commit, rootState }) {
      commit('SET_PLAN_PARAM');
      const planParam = getters.GET_PLAN_PARAM;
      planParam['searchSabun'] = rootState.userData.ssnSabun;

      //재직상태 및 신청대상자 체크
      const checkResponse = await checkAnnualPlanDet(planParam);
      const checkResponseMsg = checkResponse.data.message;
      const isMsgOK = checkResponseMsg == 'OK';
      if (!isMsgOK) {
        alert(checkResponseMsg);
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
        commit('SET_APPL_YMD', '');
        commit('SET_APPL_YMD_WEEK', '');
      } else if (Number(checkResponse.data.data.dupCnt) > 0) {
        alert('해당일에 기 신청건이 존재합니다.');
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
        return;
      } else {
        commit('SET_HALF_YN');
        commit('SET_CLOSE_DAY', checkResponse.data.data);
      }

      return isMsgOK;
    },

    // ======================= VACATION =======================
    // 잔여일수 조회
    async FETCH_REST_CNT({ state, getters, commit }) {
      commit('SET_VACATION_PARAM');
      const response = await getRestCnt(getters.GET_VACATION_PARAM);
      state.restCnt = response.data.data.restCnt;
    },
    //2025.03.10 휴일근무일자 조회 중간에 컬럼명 변경으로 인해 정상적으로 데이터를 넘겨주지 않는 부분 세팅
    async FETCH_SET_PARAMS({ state, getters, commit }) {
      //console.log('Before setting alterVacation:', state.alterVacation);
      commit('SET_VACATION_PARAM');
      const alterCode = getters.GET_ALTER_VACATION?.code || '';
      state.holWorkYmd = alterCode ? alterCode.replace(/-/g, '') : '';
      //console.log('After setting holWorkYmd:', state.holWorkYmd);
      commit('SET_HOL_WORK_YMD', state.holWorkYmd);
    },
    // 전체일수, 휴일일수 조회
    async FETCH_HOLI_CNT({ getters, commit }) {
      commit('SET_VACATION_PARAM');
      const response = await getHoliCnt(getters.GET_VACATION_PARAM);
      commit('SET_CLOSE_DAY', response.data.data);
    },
    // 적용시간 조회
    async FETCH_HOUR({ getters, commit }) {
      commit('SET_VACATION_PARAM');
      const response = await getHour(getters.GET_VACATION_PARAM);
      commit('SET_REQUEST_HOUR', response.data.data.restTime);
    },
    //2025.03.19 근태별 첨부파일필수여부 확인
    async FETCH_GNT_FILE_ESS_YN({ getters, commit }) {
      const response = await getApprovalMgrApplFileEssYn({
        searchApplCd: getters.GET_CANCEL_PARAM.searchApplCd,
        searchGntGubunCd: getters.GET_GNT_GUBUN_CD,
      });
      const data = response.data.data;
      commit('SET_GNT_FILE_ESS_YN', data.gntFileEssYn);
    },
    // 근태 - 확인
    async VALIDATE_VACATION_DET({ getters, commit }) {
      commit('SET_VACATION_PARAM');
      const vacationParam = getters.GET_VACATION_PARAM;

      //재직상태 및 신청대상자 체크
      const checkResponse = await checkVacationDet(vacationParam);
      const checkResponseMsg = checkResponse.data.data.msg;
      const isMsgOK = checkResponseMsg == 'OK';
      if (!isMsgOK) {
        alert(checkResponseMsg);
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
        commit('SET_APPL_YMD', '');
        commit('SET_APPL_YMD_WEEK', '');
      }

      return isMsgOK;
    },

    // 근태 - 저장
    async SAVE_VACATION_DET({ getters, dispatch }) {
      let returnValue = false;

      // 신청 확인
      const validResult = await dispatch(
        'BEFORE_SAVE',
        'VALIDATE_VACATION_DET',
      );
      if (!validResult) return returnValue;

      // 신청 저장
      const vacationParam = getters.GET_VACATION_PARAM;
      const saveResponse = await postVacationDet(vacationParam);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    // ======================= OTWORK =======================
    // 연장근무 - 휴일근무 보상구분 조회
    async FETCH_OT_WORK_SYS_INFO({ commit }) {
      commit('SET_OTWORK_PARAM');
      const response = await getOtWorkSysInfo();
      const data = response.data.data;

      commit('SET_REQ_TIME_CD', data.reqHolWork);
      commit('SET_ALTVAC_APPL_STATUS', data.altvacApplStatus);
      commit('SET_ORG_LVL', data.orgLvl); // 연장근무 orgLvl 메인위젯에서 등록시 set

      return response.data.data.reqHolWork;
    },

    // 연장근무 - 확인
    async VALIDATE_OT_WORK_STATUS({ getters, commit, dispatch }) {
      let returnData = false;
      commit('SET_OTWORK_PARAM');

      const response = await getOtWorkStatus(getters.GET_OTWORK_PARAM);
      const data = response.data.data;

      if (data === undefined) {
        alert('해당 일에 근무스케줄이 없습니다. 담당자에게 문의하세요.');
        commit('SET_WORK_YMD', '');
        return returnData;
      }
      if (data.statusCd !== 'AA') {
        alert('해당 일에 재직상태가 아닙니다.');
        commit('SET_WORK_YMD', '');
        return returnData;
      }
      if (data.beginShm === null || data.beginShm === '') {
        alert('해당 일에 근무스케줄이 없습니다. 담당자에게 문의하세요.');
        commit('SET_WORK_YMD', '');
        return returnData;
      }

      commit('SET_HOL_YN', data.holYn); // 휴일 여부
      commit('SET_APPL_GUBUN', data.applGubun); // 보상기준
      commit('SET_IN_OUT', data); // 출퇴근시간

      // 적용시간 조회
      if (getters.GET_REQ_S_E_HM !== '') {
        dispatch('FETCH_OT_DIRECT_YN');
        dispatch('FETCH_OT_WORK_HOUR');
      }

      return !returnData;
    },

    // 연장근무 - 시간 조회
    async FETCH_OT_WORK_HOUR({ getters, commit }) {
      commit('SET_OTWORK_PARAM');
      const response = await getOtWorkHour(getters.GET_OTWORK_PARAM);
      const data = response.data.data;
      const dataHour = data.hour + data.holOtHour;
      console.log(data.hour + '//' + data.holOtHour);
      commit('SET_REST_HOUR', data.restHour);
      commit('SET_REQUEST_HOUR', dataHour);
      commit('SET_BASIC_HOUR', data.hour);
      commit('SET_HOL_OT_HOUR', data.holOtHour);

      //2025.03.12 개인 근무유형별 연장근무 직접입력가능 여부 Y인 경우 초기값을 넣어준다.
      if (getters.GET_OT_INFO_DIRECT_YN === 'Y') {
        commit('SET_DIRECT_REQUEST_HOUR', data.restHour);
        commit('SET_DIRECT_REST_HOUR', dataHour);
      }
    },

    // 2025.03.12 연장근무 - 개인 근무유형별 연장근무 직접입력가능 여부 조회
    async FETCH_OT_DIRECT_YN({ getters, commit }) {
      commit('SET_OTWORK_PARAM');
      const response = await getOtDirectYn(getters.GET_OTWORK_PARAM);
      const data = response.data.data;
      console.log(data.otInfoDirectYn);
      commit('SET_OT_INFO_DIRECT_YN', data.otInfoDirectYn);
    },

    // 연장근무 - 확인
    async VALIDATE_OT_WORK_DET({ getters, commit }) {
      commit('SET_OTWORK_PARAM');

      const response = await checkOtWorkDet(getters.GET_OTWORK_PARAM);
      const checkResponseMsg = response.data.data.msg;
      const isMsgOK = checkResponseMsg == 'OK';
      if (!isMsgOK) {
        alert(checkResponseMsg);
        // commit('SET_WORK_YMD', '');
        // commit('SET_WORK_WEEK', '');
        // commit('SET_REQUEST_HOUR', '');
      }

      return isMsgOK;
    },

    // 연장근무 - 저장
    async SAVE_OT_WORK_DET({ getters, dispatch }) {
      let returnValue = false;

      const validResult = await dispatch('BEFORE_SAVE', 'VALIDATE_OT_WORK_DET');
      if (!validResult) return returnValue;

      // 신청 저장
      const vacationParam = getters.GET_OTWORK_PARAM;
      const saveResponse = await postOtWorkDet(vacationParam);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    // ======================= SCHEDULE =======================
    // 근무스케줄 - 상태확인 및 스케줄 정보 조회
    async VALIDATE_SCHEDULE_STATUS({ getters, commit }) {
      let returnData = false;
      commit('SET_SCHEDULE_PARAM');

      const response = await getScheduleStatus(getters.GET_SCHEDULE_PARAM);
      const data = response.data.data;

      if (data.statusCd !== 'AA') {
        alert('해당 일에 재직상태가 아닙니다.');
        commit('SET_WORK_YMD', '');
        return returnData;
      }

      commit('SET_SEARCH_WORK_TYPE_CD', data.workTypeCd);
      commit('SET_WORK_ORG_CD', data.workOrgCd);
      commit('SET_INTERVAL_CD', data.workCycleCd);
      commit('SET_WORK_ORG_NM', data.workOrgNm);
      commit('SET_DAY_GUBUN_CD', '1');

      return !returnData;
    },

    // 근무스케줄 - 기 신청건 체크
    async VALIDATE_SCHEDULE_DET({ getters, commit }) {
      commit('SET_SCHEDULE_PARAM');

      const response = await checkScheduleDet(getters.GET_SCHEDULE_PARAM);
      const checkCnt = response.data.data.cnt;
      const isOk = checkCnt === 0;
      if (!isOk) {
        alert(
          '해당 근무일에 신청한 신청건이 결재처리 중으로 중복 신청할 수 없습니다.',
        );
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
      }

      return isOk;
    },

    // 근무스케줄 - 근무유형 근무시간 조회
    async FETCH_WORK_ORG_TIME_LIST({ state, commit }) {
      const response = await getWorkOrgTimeList({
        searchWorkTypeCd: state.searchWorkTypeCd,
      });
      commit('SET_WORK_ORG_TIME_LIST', response.data.data);
    },

    // 근무스케줄 - 저장
    async SAVE_SCHEDULE_DET({ getters, dispatch }) {
      let returnValue = false;

      const validResult = await dispatch(
        'BEFORE_SAVE',
        'VALIDATE_SCHEDULE_DET',
      );
      if (!validResult) return returnValue;

      // 신청 저장
      const saveResponse = await postScheduleDet(getters.GET_SCHEDULE_PARAM);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },
    // ======================= REWARD =======================

    // 전체일수, 휴일일수 조회
    async FETCH_REWARD_HOLI_CNT({ getters, commit }) {
      commit('SET_REWARD_PARAM');
      const response = await getRewardHoliCnt(getters.GET_REWARD_PARAM);
      const resData = response.data.data;
      commit('SET_CLOSE_DAY', resData);
      const holDay = Number(resData.holDay);
      commit(
        'SET_REQUEST_HOUR',
        (holDay - resData.holidayCnt) * resData.stdApplyHour,
      );
    },

    // 보상휴가 - 보상 목록 조회
    async FETCH_REWARD_LIST({ getters, commit }) {
      commit('SET_REWARD_PARAM');
      const response = await getRewardList(getters.GET_REWARD_PARAM);
      commit('SET_REWARD_LIST', response.data.data);
    },

    // 보상휴가 - 확인
    async VALIDATE_REWARD_DET({ getters, commit }) {
      commit('SET_REWARD_PARAM');

      //재직상태 및 신청대상자 체크
      const checkResponse = await checkRewardDet(getters.GET_REWARD_PARAM);
      const checkResponseMsg = checkResponse.data.data.msg;
      const isMsgOK = checkResponseMsg == 'OK';
      if (!isMsgOK) {
        alert(checkResponseMsg);
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
      }

      return isMsgOK;
    },

    // 보상휴가 - 저장
    async SAVE_REWARD_DET({ getters, dispatch }) {
      let returnValue = false;

      // 신청 확인
      const validResult = await dispatch('BEFORE_SAVE', 'VALIDATE_REWARD_DET');
      if (!validResult) return returnValue;

      const rewardSaveParam = {
        ...getters.GET_REWARD_PARAM,
        mergeRows: getters.GET_USE_REWARD_LIST,
      };

      // 신청 저장
      const saveResponse = await postRewardDet(rewardSaveParam);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    // ======================= ATTEND =======================
    // 출퇴근변경신청 - 상태확인 및 스케줄 정보 조회
    async VALIDATE_ATTEND_STATUS({ getters, commit }) {
      console.log('VALIDATE_ATTEND_STATUS');
      let returnData = false;
      commit('SET_ATTEND_PARAM');
      console.log('VALIDATE_ATTEND_STATUS2');

      const response = await getAttendStatus(getters.GET_ATTEND_PARAM);
      const data = response.data.data;
      console.log('VALIDATE_ATTEND_STATUS3');

      if (data.statusCd !== 'AA') {
        alert('해당 일에 재직상태가 아닙니다.');
        commit('SET_WORK_YMD', '');
        return returnData;
      }

      if (data.inOut !== null && data.inOut !== '|') {
        const inOut = data.inOut.split('|');
        commit('SET_BEFORE_START_HM', inOut[0]);
        commit('SET_BEFORE_END_HM', inOut[1]);
      } else {
        commit('SET_BEFORE_START_HM', '');
        commit('SET_BEFORE_END_HM', '');
      }

      return !returnData;
    },

    // 출퇴근변경신청 - 확인
    async VALIDATE_ATTEND_DET({ getters, commit }) {
      let returnData = false;
      commit('SET_ATTEND_PARAM');

      //재직상태 및 신청대상자 체크
      const checkResponse = await checkAttendDet(getters.GET_ATTEND_PARAM);
      const checkResponseMsg = checkResponse.data.data.chkMsg;
      const checkCnt = checkResponse.data.data.cnt;
      const isOk = checkCnt === 0;

      if (!isOk) {
        alert(
          '해당 근무일에 신청한 신청건이 결재처리 중으로 중복 신청할 수 없습니다.',
        );
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
        return returnData;
      }

      if (checkResponseMsg !== null && checkResponseMsg !== '') {
        alert(`신청 가능한 근무일은 ${checkResponseMsg}입니다.`);
        return returnData;
      }

      return !returnData;
    },

    // 출퇴근변경신청 - 저장
    async SAVE_ATTEND_DET({ getters, dispatch }) {
      let returnValue = false;

      // 신청 확인
      const validResult = await dispatch('BEFORE_SAVE', 'VALIDATE_ATTEND_DET');
      if (!validResult) return returnValue;

      const attendSaveParam = {
        ...getters.GET_ATTEND_PARAM,
      };

      // 신청 저장
      const saveResponse = await postAttendDet(attendSaveParam);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    // ======================= BIZTRIP =======================
    // 출장신청 신청일 휴일체크조회
    async FETCH_BIZTRIP_HOLI_CNT({ state, getters }) {
      const param = {
        searchApplSabun: getters.GET_ELA_APPL_PARAM.searchApplSabun,
        sdate: dayjs(getters.GET_S_YMD).format('YYYYMMDD'),
        edate: dayjs(getters.GET_E_YMD).format('YYYYMMDD'),
        gntCd: getters.GET_GNT_CD,
      };
      const response = await checkHolCnt(param);
      const resData = response.data.data;

      // 결과값 state에 저장
      const holDay = Number(resData.holDay);
      const closeDay = holDay - Number(resData.holidayCnt);

      if (closeDay === 0) {
        alert('출장 일수가 0일 입니다. 휴일포함여부를 담당자에게 확인하세요.');
        return false;
      } else {
        // 전체일수, 휴일일수 store에 저장
        state.holDay = holDay;
        state.closeDay = closeDay; // SET_CLOSE_DAY_DATA
        return true;
      }
    },

    // 출장신청서 상세조회
    async FETCH_BIZ_TRIP_APP_DET({ getters, commit }) {
      const param = {
        ...getters.GET_ELA_APPL_PARAM,
        // searchApplYmd: dayjs().format('YYYYMMDD'),
        gntCd: getters.GET_GNT_CD, // ** 신청서작성시에는 앞에서 선택한 gntCd 값을 넘겨야함
      };
      const response = await getBizTripAppDet(param); // api 호출

      commit('SET_BIZ_TRIP_DET', response.data.data); // 결과값 state에 저장
    },

    // 출장신청서 저장(신청)
    async SAVE_BIZ_TRIP_DET({ getters }) {
      try {
        // 1. 본인결재 체크
        if (
          getters.GET_UI_INFO?.pathSelfCloseYn == 'N' &&
          (getters.GET_APPL_USER_LIST?.length ?? 0) < 2
        ) {
          alert(
            '결재선이 본인만 지정되었습니다. 결재자를 추가로 지정하여 신청해 주십시요.',
          );
          return false;
        }

        // 2. 출장신청서 동적컬럼을 key-value 형태로 변환
        const dynamicColsRaw = getters.GET_BIZ_TRIP_DYNAMIC_COLS ?? [];
        const dynamicCols = dynamicColsRaw.reduce((acc, col) => {
          acc[(col?.columnId ?? '').toLowerCase()] = col?.colVal ?? '';
          return acc;
        }, {});

        // 3. 동행인 목록에 신청자 본인 추가
        const mergeRows = Array.isArray(getters.GET_BIZ_TRIP_JOINER)
          ? [...getters.GET_BIZ_TRIP_JOINER]
          : [];
        mergeRows.push({
          sabun: getters.GET_USER_INFO?.sabun ?? '',
          name: getters.GET_USER_INFO?.name ?? '',
          sabunNote: getters.GET_BIZ_TRIP_SABUN_NOTE?.userNote ?? '',
        });

        // 4. 출장신청서 저장용 파라미터 생성
        const bizTripSaveParam = {
          ...getters.GET_ELA_APPL_PARAM, // 신청 기본 파라미터
          ...dynamicCols, // 2번에서 가공한 동적 컬럼 데이터
          title: getters.GET_BIZ_TRIP_TITLE.colVal, // 출장제목
          sdate: dayjs(getters.GET_S_YMD).format('YYYYMMDD'), // 출장기간
          edate: dayjs(getters.GET_E_YMD).format('YYYYMMDD'),
          gntCd: getters.GET_GNT_CD,
          closeDay: getters.GET_CLOSE_DAY,
          holDay: getters.GET_HOL_DAY,
          mergeRows: mergeRows, // 동행인 목록
        };

        // 5. 신청 저장 api 호출
        const res = await postBizTripAppDet(bizTripSaveParam);
        const saveResponse = res?.data ?? {};
        // console.log('### SAVE_BIZ_TRIP_DET response:', saveResponse);

        // 6. return
        if (saveResponse.errorMessage) {
          alert(saveResponse.errorMessage);
          return false;
        }

        if (saveResponse.data < 1) {
          // ** IO.Message가 있으면 그걸 우선
          const msg =
            saveResponse?.IO?.Message ?? saveResponse?.message ?? '저장 실패';
          alert(msg);
          return false;
        }
        return true;
      } catch (e) {
        console.error('SAVE_BIZ_TRIP_DET error:', e);
        alert(
          '저장 중 예상치 못한 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
        );
        return false;
      }
    },

    // ======================= CERTI =======================
    // 용도 코드목록조회
    async FETCH_PURPOSE_CD_LIST({ commit }) {
      var grpCd = "'C80001'";
      const response = await getEmpCommonCode({ grpCd: grpCd });
      commit('SET_PURPOSE_CD_LIST', response.data.data);
    },

    // 제증명신청서 저장
    async SAVE_CERTI_DET({ getters }) {
      let returnValue = false;

      // 본인결재 체크
      if (
        getters.GET_UI_INFO.pathSelfCloseYn === 'N' &&
        getters.GET_APPL_USER_LIST.length < 2
      ) {
        alert(
          '결재선이 본인만 지정되었습니다. 결재자를 추가로 지정하여 신청해 주십시요.',
        );
        return returnValue;
      }

      const certiSaveParam = {
        ...getters.GET_CERTI_PARAM,
        ...getters.GET_ELA_APPL_PARAM,
        note: getters.GET_REASON,
      };

      // 신청 저장
      const saveResponse = await postCertiDet(certiSaveParam);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    // ======================= CANCEL =======================
    // 취소신청 - 확인
    async VALIDATE_CANCEL_DET({ getters }) {
      const cancelParam = getters.GET_CANCEL_PARAM;
      let checkResponse = {};
      if (cancelParam.searchApplCd === '23') {
        checkResponse = await checkCancelVacation(cancelParam);
      } else if (cancelParam.searchApplCd === '43') {
        checkResponse = await checkCancelReward(cancelParam);
      }

      //재직상태 및 신청대상자 체크
      const checkCnt = checkResponse.data.data.cnt;
      const isOk = checkCnt === 0;
      if (!isOk) {
        alert(
          '해당 근무일에 신청한 신청건이 결재처리 중으로 중복 신청할 수 없습니다.',
        );
      }

      return isOk;
    },

    // 근태 - 저장
    async SAVE_CANCEL_DET({ getters, dispatch }) {
      let returnValue = false;

      // 신청 확인
      const validResult = await dispatch('BEFORE_SAVE', 'VALIDATE_CANCEL_DET');
      if (!validResult) return returnValue;

      // 신청 저장
      const cancelParam = getters.GET_CANCEL_PARAM;
      let saveResponse = {};
      if (cancelParam.searchApplCd === '23') {
        saveResponse = await postCancelVacation(cancelParam);
      } else if (cancelParam.searchApplCd === '43') {
        saveResponse = await postCancelReward(cancelParam);
      }

      if (
        saveResponse.errorMessage != '' &&
        saveResponse.errorMessage != undefined
      ) {
        alert(saveResponse.errorMessage);
        return returnValue;
      } else if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    async BEFORE_SAVE({ getters, dispatch }, validateApiName) {
      let returnValue = false;
      // 본인결재 체크
      if (
        getters.GET_UI_INFO.pathSelfCloseYn === 'N' &&
        getters.GET_APPL_USER_LIST.length < 2
      ) {
        alert(
          '결재선이 본인만 지정되었습니다. 결재자를 추가로 지정하여 신청해 주십시요.',
        );
        return returnValue;
      }

      //재직상태 및 신청대상자 체크
      const checkResponse = await dispatch(validateApiName);
      if (!checkResponse) return returnValue;

      return !returnValue;
    },
  },
};

export default application;
